import React from 'react';

import { Avatar } from 'antd';
import { UserOutlined } from '@ant-design/icons';

import styles from './OverlappedAvatars.module.css';

type OverlappedAvatarsProps = {
  avatars: string[];
  size?: number;
  avatarsToShow?: number;
  onRemainderClick?: () => void;
};

export const OverlappedAvatars: React.FC<OverlappedAvatarsProps> = ({
  avatars,
  size = 32,
  avatarsToShow = 3,
  onRemainderClick,
}) => {
  const isHaveRemainder = avatars.length > avatarsToShow;

  const remainder = isHaveRemainder ? avatars.length - avatarsToShow : 0;

  const truncatedAvatars = isHaveRemainder
    ? avatars.slice(0, avatarsToShow)
    : avatars;

  return (
    <>
      {truncatedAvatars.map((item, index) => (
        <Avatar
          key={index}
          size={size}
          src={item}
          alt={item}
          icon={<UserOutlined />}
          className={styles.avatar}
        />
      ))}
      {isHaveRemainder && (
        <span className={styles.remainder} onClick={onRemainderClick}>
          <Avatar
            size={size}
            className={styles.avatar}
            style={{ backgroundColor: '#1A95C2' }}
          >
            +{remainder > 99 ? 99 : remainder}
          </Avatar>
        </span>
      )}
    </>
  );
};
